import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { Box, Fab } from '@material-ui/core'
import { CloudDownload, HighlightOffOutlined } from '@material-ui/icons'

import { download } from '../../utils'
import { FilePreview } from './FilePreview'

interface UrlPreviewProps {
  url: string
  allowDownload?: boolean
  onDelete?: () => void
}

export const UrlPreview = (props: UrlPreviewProps) => {
  const { allowDownload = true, onDelete, url } = props
  const [file, setFile] = useState<File>(new File([], url))
  const [, setError] = useState(false)
  const [hover, setHover] = useState(false)

  let name = url.split('/').pop() || 'download'
  name = name.split('?')[0]

  useEffect(() => {
    const source = axios.CancelToken.source()
    setFile(new File([''], name, { type: 'loading/none' }))
    axios({ url, responseType: 'blob', cancelToken: source.token })
      .then((response) => {
        setFile(new File([response.data], name, { type: response.data.type }))
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          setError(true)
        }
      })
    return () => {
      source.cancel('Canceling call to fetch url!')
    }
  }, [url, name])

  return (
    <Box
      position="relative"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <FilePreview file={file} />
      {hover && allowDownload && (
        <Box position="absolute" zIndex="modal" top="5%" right="10%">
          <Fab size="small" onClick={() => download(url, name)}>
            <CloudDownload />
          </Fab>
        </Box>
      )}
      {hover && !!onDelete && (
        <Box position="absolute" zIndex="modal" top="5%" right="10%">
          <Fab size="small" onClick={() => onDelete()}>
            <HighlightOffOutlined />
          </Fab>
        </Box>
      )}
    </Box>
  )
}
